import { render } from "./pca-dictionary-grid.vue?vue&type=template&id=02bb410a"
import script from "./pca-dictionary-grid.vue?vue&type=script&setup=true&lang=js"
export * from "./pca-dictionary-grid.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/print-contract/components/pca-dictionary-grid.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "02bb410a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('02bb410a', __exports__)) {
    api.reload('02bb410a', __exports__)
  }
  
  module.hot.accept("./pca-dictionary-grid.vue?vue&type=template&id=02bb410a", () => {
    api.rerender('02bb410a', render)
  })

}


export default __exports__